import MoveMessageProvider from './MoveMessageContext';
import MoveMessage from './MoveMessage';

interface IProps {
    messageId: string
}

let Index = (props: IProps) => {
    return (
        <MoveMessageProvider {...props}>
            <MoveMessage />
        </MoveMessageProvider>
    )
}

export default Index;